module.exports = __webpack_public_path__ + "static/img/9.913f2b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/zh/9.png
// module id = wF04
// module chunks = 0